import React from 'react';
import { SvgIcon } from '../components/svgIcon';
import { SvgIconProps } from '../components/svgIcon/model';

export const ArrowLeftIcon = React.forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => {
  return (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    <SvgIcon cacheName="arrowLeft" ref={ref as any} {...props}>
      <path
        d="M7.84939 16.2232C8.13336 16.5122 8.59387 16.5122 8.8779 16.2232C9.16192 15.9341 9.16192 15.4654 8.8779 15.1763L6.48303 12.7386H19.2727C19.6744 12.7386 20 12.4072 20 11.9984C20 11.5896 19.6744 11.2581 19.2727 11.2581H6.48303L8.87785 8.8205C9.16187 8.53145 9.16187 8.06272 8.87785 7.77362C8.73589 7.62912 8.54975 7.55682 8.36362 7.55682C8.17748 7.55682 7.99135 7.62912 7.84939 7.77367L4.21302 11.475C3.92899 11.764 3.92899 12.2328 4.21302 12.5219L7.84939 16.2232Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
});
